import bike1 from "./IMG_0159.webp";
import bike2 from "./IMG_0172.webp";
import bike3 from "./IMG_0186.webp";
import bike4 from "./IMG_0236.webp";
import bike5 from "./IMG_0249.webp";
import bike6 from "./IMG_0248.webp";
import bike7 from "./20240811_091547.webp";
import bike8 from "./20240811_091537.webp";
import bike9 from "./rowery.webp";
import bike10 from "./IMG_0177.webp";
import bike11 from "./IMG_0232.webp";
import bike12 from "./IMG_0252.webp";

export const bikesImages = [bike1, bike2, bike3, bike4, bike5, bike6, bike7, bike8, bike9, bike10, bike11, bike12];